import request from '@/utils/request'
import URL from './urlTranslator'

/**
 * 通用组件API
 */

// 收付类型
export function getArApDropDownList(params) {
  return request({
    url: `${URL.act.arApDropDownList}`,
    method: 'get',
    params
  })
}

// 收付款申请-结算方式
export function getPayTypeDropDownList(params) {
  return request({
    url: `${URL.act.payTypeDropDownList}`,
    method: 'get',
    params
  })
}

// 核销详情-结算方式
export function getPayTypeForClearDropdownList(params) {
  return request({
    url: `${URL.act.payTypeForClearDropdownList}`,
    method: 'get',
    params
  })
}

// 客商列表-全部
export function getPartnerDropDownList(params) {
  return request({
    url: `${URL.sys.partnerDropDownList}`,
    method: 'get',
    params
  })
}

// 客商列表-工作号-费用-收付申请向导
export function getCustomerDropDownListByJobForPayment(data) {
  return request({
    url: `${URL.act.customerDropDownListByJobForPayment}`,
    method: 'post',
    data
  })
}

export function currencyDropDownList() {
  return request({
    url: `${URL.dmn.currencyDropDownList}`,
    method: 'get'
  })
}

export function getFeeItemDropdownList() {
  return request({
    url: `${URL.act.feeItemDropdownList}`,
    method: 'get'
  })
}
export function getCompanyList() {
  return request({
    url: URL.sys.companyList,
    method: 'get'
  })
}

//
export function getGlobalQueryConfig(configType, configModule) {
  const params = { configType, configModule }
  return request({
    url: URL.mdm.getGlobalQueryConfig,
    method: 'get',
    params
  })
}
export function getPersonQueryConfig(perConfig) {
  const params = { ...perConfig }
  // console.log('params:', params)
  return request({
    url: URL.mdm.personQueryConfig,
    method: 'get',
    params
  })
}
export function getStaSchemaTree() {
  return request({
    url: URL.sys.getStaSchemaTree,
    method: 'get'
  })
}
// 验证表格个人配置中需要更新的部分
export function validateNeedUpdatedGridStatus(data) {
  return request({
    url: URL.mdm.validateNeedUpdatedGridStatus,
    method: 'post',
    data
  })
}
export function setDefault(data) {
  return request({
    url: URL.mdm.setDefault,
    method: 'post',
    data
  })
}
export function savePersonQueryConfig(data) {
  return request({
    url: URL.mdm.personQueryConfig,
    method: 'post',
    data
  })
}
export function saveShareQueryConfig(data) {
  return request({
    url: URL.sys.shareQueryConfig,
    method: 'post',
    data
  })
}
export function delPersonQueryConfig(id) {
  return request({
    url: URL.mdm.personQueryConfig + `/${id}`,
    method: 'delete'
  })
}
// 通过id或配置名称删除个人配置
export function delPerConfigByIdOrConfigName(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.mdm.deletePerConfigByIdOrConfigName,
    method: 'post',
    data
  })
}
export function updatePersonQueryConfig(data, id) {
  return request({
    url: URL.mdm.personQueryConfig + `/${id}`,
    method: 'put',
    data
  })
}
// 高级查询
export function getAdvQueryResult(url, data) {
  return request({
    url: url,
    method: 'post',
    data
  })
}
// 简单查询
export function getSimQueryResult(url, params) {
  return request({
    url: url,
    method: 'get',
    params
  })
}

export function queryModuleListFunc() {
  return request({
    url: URL.sys.queryModuleListUrl,
    method: 'get'
  })
}

// 查询待办事项子类列表
export function queryTodoCategoryFunc(params) {
  return request({
    url: URL.sys.queryCategoryListUrl,
    method: 'get',
    params: params
  })
}

// 获取待办统计
export function countTodoItemFunc(params) {
  return request({
    url: URL.sys.countTodoItemUrl,
    method: 'get',
    params: params
  })
}

// 查询待办事项
export function queryTodoItemFunc(data) {
  return request({
    url: URL.sys.queryTodoItemUrl,
    method: 'post',
    data: data
  })
}

// 标记预警消息为已完成
export function batchCompletedItemFunc(data) {
  return request({
    url: URL.sys.batchCompletedItemUrl,
    method: 'post',
    data: data
  })
}
